import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  tone?: "emerald" | "muted";
  testId?: string;
}

const tones = {
  emerald: "border-emerald-500/25 bg-emerald-500/10 text-emerald-400",
  muted: "border-slate-700 bg-slate-800/60 text-slate-300",
};

export function Badge({ children, tone = "emerald", testId }: BadgeProps) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] sm:text-xs ${tones[tone]}`}
    >
      {children}
    </span>
  );
}
